import { v4 as uuidv4 } from 'uuid';
import { normalizeHexColor } from './richText.js';
import { normalizeStoredImageItem, revokeLocalImageUrl } from './localImage.js';
import { LOCAL_ASSET } from './localAssets.js';
import { getQiniuSignedUrl } from './qiniuMedia.js';

export const HEADER_HERO_COMPONENT_TYPE = 'header-hero';
export const HEADER_HERO_MODULE_TYPE = 'hero';

export const HEADER_HERO_DEFAULT_HEIGHT = 300;
export const HEADER_HERO_DEFAULT_BORDER_RADIUS = 20;

const DEFAULT_TITLE = '跨境电商选品情报库';
const DEFAULT_SUBTITLE = '趋势数据 · 爆款拆解 · 供应链清单';
const DEFAULT_BUTTON_TEXT = '立即查看资料';
const DEFAULT_TITLE_COLOR = '#ffffff';
const DEFAULT_SUBTITLE_COLOR = '#ffffff';
const DEFAULT_BUTTON_BG_COLOR = '#ffcf00';
const DEFAULT_BUTTON_TEXT_COLOR = '#000000';

function createDefaultHeroImage() {
	return {
		id: `header-hero-bg-${uuidv4()}`,
		filename: 'hero-bg.jpg',
		previewUrl: LOCAL_ASSET.headerHero,
		url: '',
		local: false,
	};
}

export function getHeaderHeroImageUrl(image) {
	if (!image) return '';
	return getQiniuSignedUrl(image.previewUrl || image.url || '');
}

export function getHeaderHeroDefaults() {
	return normalizeHeaderHeroData({});
}

export function isHeaderHeroComponent(type) {
	return type === HEADER_HERO_COMPONENT_TYPE;
}

function normalizeHeroImage(image) {
	if (!image?.previewUrl && !image?.url) {
		return createDefaultHeroImage();
	}
	return normalizeStoredImageItem(image, createDefaultHeroImage());
}

function normalizeHeroLogo(image) {
	if (!image?.previewUrl && !image?.url) {
		return null;
	}
	return normalizeStoredImageItem(image);
}

export function normalizeHeaderHeroData(data = {}) {
	return {
		title: typeof data.title === 'string' ? data.title : DEFAULT_TITLE,
		subtitle: typeof data.subtitle === 'string' ? data.subtitle : DEFAULT_SUBTITLE,
		buttonText: typeof data.buttonText === 'string' ? data.buttonText : DEFAULT_BUTTON_TEXT,
		titleColor: normalizeHexColor(data.titleColor || DEFAULT_TITLE_COLOR),
		subtitleColor: normalizeHexColor(data.subtitleColor || DEFAULT_SUBTITLE_COLOR),
		buttonBgColor: normalizeHexColor(data.buttonBgColor || DEFAULT_BUTTON_BG_COLOR),
		buttonTextColor: normalizeHexColor(data.buttonTextColor || DEFAULT_BUTTON_TEXT_COLOR),
		height: Math.max(80, Number(data.height) || HEADER_HERO_DEFAULT_HEIGHT),
		borderRadius: Math.max(0, Number(data.borderRadius) || HEADER_HERO_DEFAULT_BORDER_RADIUS),
		showBg: data.showBg !== false,
		darkOverlay: data.darkOverlay === true,
		showLogo: data.showLogo === true,
		image: normalizeHeroImage(data.image),
		logo: normalizeHeroLogo(data.logo),
		jumpLink: data?.jumpLink?.type ? { ...data.jumpLink } : null,
	};
}

export function revokeHeaderHeroImages(data) {
	revokeLocalImageUrl(data?.image?.previewUrl);
	revokeLocalImageUrl(data?.logo?.previewUrl);
}
